import CardHeader from "./CardHeader";
import CardBody from "./CardBody";

const Card = (props) => {
    const {className} = props;

    return (
        <div className={'card ' + className}>
            {props.children}
        </div>
    );
};

Card.defaultProps = {
    className: '',
};

Card.Header = CardHeader;
Card.Body = CardBody;

export default Card;